import { render, staticRenderFns } from "./PeopleDetail.vue?vue&type=template&id=c51ac618&scoped=true"
import script from "./PeopleDetail.vue?vue&type=script&lang=js"
export * from "./PeopleDetail.vue?vue&type=script&lang=js"
import style0 from "./PeopleDetail.vue?vue&type=style&index=0&id=c51ac618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51ac618",
  null
  
)

export default component.exports